module.exports = __webpack_public_path__ + "static/media/poster4.1c59b32a.png";